import apiClient from "../api_client/apiClient";

export const permissionsService = {
  me: () => apiClient.get("/genesis/permissions/me"),
};
